import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseSupplierScoring, SupplierRating } from '../../types/advise';

export const supplierScoringUrl = (engagementId: string) => `api/advise/engagements/${engagementId}/supplier_scoring`;

export const fetchAdviseSupplierScoring = async (engagementId: string): Promise<CallResult<AdviseSupplierScoring>> => {
  return callExternalApi<AdviseSupplierScoring>({
    url: supplierScoringUrl(engagementId),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const updateAdviseSupplierRating = async (
  engagementId: string,
  supplierId: string,
  functionId: string,
  rating: number,
  note: string | null = null
): Promise<CallResult<SupplierRating>> => {
  return callExternalApi<SupplierRating>({
    url: `${supplierScoringUrl(engagementId)}/suppliers/${supplierId}/functions/${functionId}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: { rating, note }
  });
};
